import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur border-b border-gray-200 transition-all ${isScrolled ? 'shadow-md bg-white/98' : ''}`}>
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          <Link to="/" className="flex flex-col items-start">
            <h2 className="text-blue-800 font-bold text-xl m-0">Moxie Master</h2>
            <span className="text-gray-500 text-sm font-normal">Public School</span>
          </Link>

          <nav className={`hidden md:flex items-center ${isMenuOpen ? 'block' : ''}`}>
            <ul className="flex list-none m-0 p-0 gap-8">
              <li><Link to="/" className={`text-gray-800 font-medium text-base transition-colors hover:text-blue-800 py-2 ${location.pathname === '/' ? 'text-blue-800' : ''}`} onClick={closeMenu}>Home</Link></li>
              <li><Link to="/academics" className={`text-gray-800 font-medium text-base transition-colors hover:text-blue-800 py-2 ${location.pathname === '/academics' ? 'text-blue-800' : ''}`} onClick={closeMenu}>Academics</Link></li>
              <li><Link to="/admissions" className={`text-gray-800 font-medium text-base transition-colors hover:text-blue-800 py-2 ${location.pathname === '/admissions' ? 'text-blue-800' : ''}`} onClick={closeMenu}>Admissions</Link></li>
              <li><Link to="/facilities" className={`text-gray-800 font-medium text-base transition-colors hover:text-blue-800 py-2 ${location.pathname === '/facilities' ? 'text-blue-800' : ''}`} onClick={closeMenu}>Facilities</Link></li>
              <li><Link to="/gallery" className={`text-gray-800 font-medium text-base transition-colors hover:text-blue-800 py-2 ${location.pathname === '/gallery' ? 'text-blue-800' : ''}`} onClick={closeMenu}>Gallery</Link></li>
              <li><Link to="/news-events" className={`text-gray-800 font-medium text-base transition-colors hover:text-blue-800 py-2 ${location.pathname === '/news-events' ? 'text-blue-800' : ''}`} onClick={closeMenu}>News & Events</Link></li>
              <li><Link to="/contact" className={`text-gray-800 font-medium text-base transition-colors hover:text-blue-800 py-2 ${location.pathname === '/contact' ? 'text-blue-800' : ''}`} onClick={closeMenu}>Contact</Link></li>
              {/* <li><Link to="/terms-conditions" className={`text-gray-800 font-medium text-base transition-colors hover:text-blue-800 py-2 ${location.pathname === '/terms-conditions' ? 'text-blue-800' : ''}`} onClick={closeMenu}>Terms & Conditions</Link></li> */}
            </ul>
          </nav>

          <div className="flex items-center gap-4">
            <Link to="/admissions" className="inline-block px-6 py-2 rounded-lg font-medium text-white bg-blue-800 hover:bg-blue-900 transition-all shadow-md">Enroll Now</Link>
            <button 
              className={`md:hidden flex flex-col bg-none border-none cursor-pointer p-2 gap-1.5 ${isMenuOpen ? 'active' : ''}`}
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <span className="w-6 h-0.5 bg-gray-800 rounded transition-all" style={{ transform: isMenuOpen ? 'rotate(45deg) translate(6px, 6px)' : 'none' }}></span>
              <span className={`w-6 h-0.5 bg-gray-800 rounded transition-all ${isMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className="w-6 h-0.5 bg-gray-800 rounded transition-all" style={{ transform: isMenuOpen ? 'rotate(-45deg) translate(6px, -6px)' : 'none' }}></span>
            </button>
          </div>
        </div>
        {/* Mobile menu */}
        {isMenuOpen && (
          <nav className="md:hidden block mt-2">
            <ul className="flex flex-col gap-4 bg-white rounded-lg shadow-lg p-4">
              <li><Link to="/" className={`text-gray-800 font-medium text-base py-2 w-full text-left hover:text-blue-800 ${location.pathname === '/' ? 'text-blue-800' : ''}`} onClick={closeMenu}>Home</Link></li>
              <li><Link to="/academics" className={`text-gray-800 font-medium text-base py-2 w-full text-left hover:text-blue-800 ${location.pathname === '/academics' ? 'text-blue-800' : ''}`} onClick={closeMenu}>Academics</Link></li>
              <li><Link to="/admissions" className={`text-gray-800 font-medium text-base py-2 w-full text-left hover:text-blue-800 ${location.pathname === '/admissions' ? 'text-blue-800' : ''}`} onClick={closeMenu}>Admissions</Link></li>
              <li><Link to="/facilities" className={`text-gray-800 font-medium text-base py-2 w-full text-left hover:text-blue-800 ${location.pathname === '/facilities' ? 'text-blue-800' : ''}`} onClick={closeMenu}>Facilities</Link></li>
              <li><Link to="/gallery" className={`text-gray-800 font-medium text-base py-2 w-full text-left hover:text-blue-800 ${location.pathname === '/gallery' ? 'text-blue-800' : ''}`} onClick={closeMenu}>Gallery</Link></li>
              <li><Link to="/news-events" className={`text-gray-800 font-medium text-base py-2 w-full text-left hover:text-blue-800 ${location.pathname === '/news-events' ? 'text-blue-800' : ''}`} onClick={closeMenu}>News & Events</Link></li>
              <li><Link to="/contact" className={`text-gray-800 font-medium text-base py-2 w-full text-left hover:text-blue-800 ${location.pathname === '/contact' ? 'text-blue-800' : ''}`} onClick={closeMenu}>Contact</Link></li>
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header; 